module.exports = __webpack_public_path__ + "static/02-421ffb7fa07a89d28433a9d52bfd8cc3.png";